// Generated by purs version 0.13.8
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Variant = require("../Data.Variant/index.js");
var Formless_Class_Initial = require("../Formless.Class.Initial/index.js");
var Formless_Transform_Record = require("../Formless.Transform.Record/index.js");
var Formless_Types_Form = require("../Formless.Types.Form/index.js");
var validateAll = Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
    return "validateAll";
}))(Data_Symbol.SProxy.value)(Data_Unit.unit);
var validate = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                    return "validate";
                }))(Data_Symbol.SProxy.value)(Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Formless_Types_Form.U.value)));
            };
        };
    };
};
var submit = Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
    return "submit";
}))(Data_Symbol.SProxy.value)(Data_Unit.unit);
var setValidateAll = function (dictNewtype) {
    return function (dictHMap) {
        return function (is) {
            return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                return "setAll";
            }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(Formless_Transform_Record.wrapInputFields(dictNewtype)(dictHMap)(is), true));
        };
    };
};
var setValidate = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (i) {
                    return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                        return "modifyValidate";
                    }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(Data_Maybe.Nothing.value, Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(Data_Function["const"](i))))));
                };
            };
        };
    };
};
var setAll = function (dictNewtype) {
    return function (dictHMap) {
        return function (is) {
            return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                return "setAll";
            }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(Formless_Transform_Record.wrapInputFields(dictNewtype)(dictHMap)(is), false));
        };
    };
};
var set = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (i) {
                    return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                        return "modify";
                    }))(Data_Symbol.SProxy.value)(Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(Data_Function["const"](i)))));
                };
            };
        };
    };
};
var resetAll = Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
    return "resetAll";
}))(Data_Symbol.SProxy.value)(Data_Unit.unit);
var reset = function (dictIsSymbol) {
    return function (dictInitial) {
        return function (dictNewtype) {
            return function (dictCons) {
                return function (sym) {
                    return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                        return "reset";
                    }))(Data_Symbol.SProxy.value)(Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(Data_Function["const"](Formless_Class_Initial.initial(dictInitial))))));
                };
            };
        };
    };
};
var modifyValidateAll = function (dictNewtype) {
    return function (dictHMap) {
        return function (ifs) {
            return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                return "modifyAll";
            }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(Formless_Transform_Record.wrapInputFunctions(dictNewtype)(dictHMap)(ifs), true));
        };
    };
};
var modifyValidate = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (f) {
                    return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                        return "modifyValidate";
                    }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(Data_Maybe.Nothing.value, Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(f)))));
                };
            };
        };
    };
};
var modifyAll = function (dictNewtype) {
    return function (dictHMap) {
        return function (fs) {
            return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                return "modifyAll";
            }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(Formless_Transform_Record.wrapInputFunctions(dictNewtype)(dictHMap)(fs), false));
        };
    };
};
var modify = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (f) {
                    return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                        return "modify";
                    }))(Data_Symbol.SProxy.value)(Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(f))));
                };
            };
        };
    };
};
var loadForm = Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
    return "loadForm";
}))(Data_Symbol.SProxy.value);
var injAction = Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
    return "userAction";
}))(Data_Symbol.SProxy.value);
var asyncSetValidate = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (ms) {
                return function (sym) {
                    return function (i) {
                        return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                            return "modifyValidate";
                        }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(new Data_Maybe.Just(ms), Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(sym)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(Data_Function["const"](i))))));
                    };
                };
            };
        };
    };
};
var asyncModifyValidate = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (ms) {
                return function (s) {
                    return function (f) {
                        return Data_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                            return "modifyValidate";
                        }))(Data_Symbol.SProxy.value)(new Data_Tuple.Tuple(new Data_Maybe.Just(ms), Data_Newtype.wrap(dictNewtype)(Data_Variant.inj()(dictIsSymbol)(s)(Data_Newtype.wrap(Formless_Types_Form.newtypeInputFunction)(f)))));
                    };
                };
            };
        };
    };
};
module.exports = {
    injAction: injAction,
    set: set,
    modify: modify,
    validate: validate,
    setValidate: setValidate,
    modifyValidate: modifyValidate,
    asyncSetValidate: asyncSetValidate,
    asyncModifyValidate: asyncModifyValidate,
    reset: reset,
    setAll: setAll,
    modifyAll: modifyAll,
    validateAll: validateAll,
    setValidateAll: setValidateAll,
    modifyValidateAll: modifyValidateAll,
    resetAll: resetAll,
    submit: submit,
    loadForm: loadForm
};
